<template>
  <div>
    
    <div class="profile-content">
      <h1>My Litters</h1>
      <v-overlay :value="isLoading">
        <v-progress-circular 
          indeterminate color="primary"
          :size="70" :width="7"
        ></v-progress-circular>
      </v-overlay>
      <v-card
        v-for="litter in litters"
        :key="litter.litterId"
        class="user-profile-card"
      >
        <v-card-title>
          <router-link :to="`/litters/${litter.litterId}`">
            <p class="ml-3">Litter #{{ litter.litterId }}</p>
          </router-link>
          <v-spacer></v-spacer>

          <v-chip text-color="white" color="green">Approved</v-chip>
        </v-card-title>
        <v-card-text>
          <h3>Litter Overview:</h3>
          <p>
            Dam: {{ litter.damName }} - {{ litter.damId }}
            <v-spacer></v-spacer> Sire: {{ litter.sireName }} -
            {{ litter.sireId }} <v-spacer></v-spacer> Males:
            {{ litter.malePuppiesCount }} <v-spacer></v-spacer> Females:
            {{ litter.femalePuppiesCount }} <v-spacer></v-spacer> Whelp Date:
            {{ $dateUtils.formatDate(litter.whelpingDate) }}
          </p>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { UserInfo } from "@/types/User";
import litterService from "@/services/portal/litterService";

export default Vue.extend({
  name: "MyLitters",
  data: function () {
    return {
      litters: [],
      isLoading: false,
    };
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
  methods: {},
  created: function () {
    if (this.userInfo) {
      this.isLoading = true;
      litterService
        .getLittersByOwner(this.userInfo.personId)
        .then((res) => {
          this.litters = res.data;
          this.isLoading = false;
        })
        .catch(this.$handleError);
    }
  },
  watch: {
    userInfo: function (newVal: object) {
      this.isLoading = true;
      litterService
        .getLittersByOwner(this.userInfo.personId)
        .then((res) => {
          this.litters = res.data;
          this.isLoading = false;
        })
        .catch(this.$handleError);
    },
  },
});
</script>
